interface GP {
  name: string;
  id: number;
  type_race: string;
  type_races: number;
  type_championship: number;
}

const getDescriptionRace = (gp: GP | undefined, type: number) => {
  const length = gp?.type_race.split(" ").length;
  if (length === 1) return "";
  if (length === 2 && type === 1) return "Main";
  if (length === 2 && type === 2) return "Sprint";
  return "Type " + type;
};

const countryCodeToFlag = (code: string) => {
  if (!code || code.toLowerCase() === "non") return "🗺️";

  // Si hay múltiples países separados por *
  if (code.includes("+")) {
    return code
      .split("+")
      .map((c) =>
        c
          .split("-")[0]
          .trim()
          .toUpperCase()
          .replace(/./g, (char) =>
            String.fromCodePoint(127397 + char.charCodeAt(0)),
          ),
      )
      .join(""); // puedes cambiar a "" si las quieres pegadas
  }

  if (code.includes("-")) {
    code = code.split("-")[0];
  }

  return code
    .toUpperCase()
    .replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt(0)));
};
export { getDescriptionRace, GP, countryCodeToFlag };
